import styled from "@emotion/styled";
const Filter = ({filters, index}) => {

	return (
		<FilterContainers className="filter__wrap--dropdown" key={index}>
			<label className="filter" htmlFor={index} tabIndex="0">{filters.title}</label>
			<select name={filters.slug} id={index}>
				<option value="">All {filters.title}</option>
				{ filters.filters.map((filter) => <option value={filter.slug}>{filter.title}</option>) }
			</select>
		</FilterContainers>
	)
}

const FilterContainers = styled.div`
	width: unset !important;
	max-width: unset !important;
	display: flex;
	flex-direction: column;
`;

export default Filter;
